import * as React from 'react'
import styled from 'styled-components'
import Link from 'next/link'

import * as ds from '@bob/design-system'
import { styles as S } from '@bob/design-system'

import * as entity from '@boutique/entities'
import * as url from '@bob/url'

type HeadProps = {
  brand: entity.brand.Brand
}

export function Head({ brand }: HeadProps) {
  return (
    <Section>
      <Title>
        {brand.logo && (
          <ds.BlobPicture
            size={105}
            variant={2}
            sizing="contain"
            color="light-green"
            height={brand.logo.height ?? undefined}
            width={brand.logo.width ?? undefined}
            src={brand.logo.src}
          />
          /*<figure>
                        <img
                            height={brand.logo.height ?? undefined}
                            width={brand.logo.width ?? undefined}
                            src={brand.logo.src}
                        />
                    </figure>*/
        )}
        <S.heading.Title4 as="h1">{brand.name}</S.heading.Title4>
      </Title>
      <S.copy.Text1 as="p">{brand.descriptionShort}</S.copy.Text1>
      <S.copy.Text4 as="p">{creation(brand)}</S.copy.Text4>

      {brand.signatory && (
        <S.copy.Text3>
          Cette marque est
          <ds.Tag variant="yellow">
            <ds.icons.Hands />
            Signataire
          </ds.Tag>
          de la{' '}
          <Link prefetch={false} href={url.manifesto().path} legacyBehavior>
            <UnderlinedSpan>charte Bien ou Bien</UnderlinedSpan>
          </Link>
        </S.copy.Text3>
      )}
    </Section>
  )
}

function creation(brand: entity.brand.Brand) {
  if (brand.creation.year) {
    const creation = [`Marque créée en ${brand.creation.year}`]
    if (brand.creation.city) {
      creation.push(`à ${brand.creation.city}`)
      const loc = []
      if (brand.creation.region) {
        loc.push(brand.creation.region)
      }
      if (brand.creation.country) {
        loc.push(brand.creation.country)
      }
      if (loc.length !== 0) {
        creation.push(`(${loc.join(', ')})`)
      }
    } else if (brand.creation.country) creation.push(`(${brand.creation.country})`)
    return `${creation.join(' ')}.`
  } else return `Pays de création de la marque : ${brand.creation.country}.`
}

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;

  @media not screen and (${ds.breakpoint.TABLET}) {
    hyphens: auto;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-bottom: 30px;
  }

  ${ds.BlobPicture} {
    flex: 0;
    padding: 11.666px;
    margin: -11.666px;

    @media screen and (${ds.breakpoint.TABLET}) {
      padding: 20px;
      margin: -20px;
    }

    ${S.picture.Picture} {
      width: 105px;
      height: 105px;

      @media screen and (${ds.breakpoint.TABLET}) {
        width: 180px;
        height: 180px;
      }
    }

    ${S.picture.Image} {
      background: white;
    }
  }

  ${S.heading.Title4} {
    margin-left: 10px;
    @media screen and (${ds.breakpoint.TABLET}) {
      margin-left: 30px;
    }
  }
`

const Section = styled.section`
  @media not screen and (${ds.breakpoint.TABLET}) {
    margin-top: 45px;
  }

  ${S.copy.Text4} {
    margin-top: 10px;
  }

  ${S.copy.Text3} {
    display: block;
    align-items: center;
    margin-top: 24px;
  }

  ${ds.Tag} {
    font-size: 12px;
    height: 24px;
    margin: 0 5px 0;
    padding: 5px 10px;

    ${ds.icons.Icon} {
      width: 20px;
      height: 12px;
      margin-right: 5px;
    }
  }
`

const UnderlinedSpan = styled.span`
  text-decoration: underline;
  cursor: pointer;
`
